export const VERSION = {
  PROD: 'V. 3.3.2',
  QA: 'V. 5.19.0 (QA)',
}
